import React from "react";
import ring from "../components/yuzuk.png"; // 👈 kendi PNG'ni bu konuma attıysan tamamdır
import "./RingLoader.css";

function RingLoader() {
  return (
    <div className="ring-loader-wrapper">
      <img src={ring} alt="Yükleniyor..." className="ring-image" />
      <p className="loading-text">Yükleniyor...</p>
    </div>
  );
}

export default RingLoader;
